import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M3 7.5C3 14.944 9.056 21 16.5 21a5.27 5.27 0 0 0 5.212-4.584 1.53 1.53 0 0 0-.9-1.566l-4.396-1.875a1.46 1.46 0 0 0-1.416.122l-2.353 1.565a7.17 7.17 0 0 1-3.3-3.28L10.903 9c.28-.42.33-.952.131-1.416L9.15 3.187a1.53 1.53 0 0 0-1.566-.9A5.27 5.27 0 0 0 3 7.5m1.5 0a3.75 3.75 0 0 1 3.272-3.722l1.884 4.397-1.565 2.381a1.5 1.5 0 0 0-.094 1.472 8.67 8.67 0 0 0 4.012 3.994 1.5 1.5 0 0 0 1.472-.103l2.344-1.566 4.397 1.875A3.75 3.75 0 0 1 16.5 19.5c-6.625-.005-11.995-5.375-12-12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }